export default class Participant {
  public static readonly PARTICIPANT_INFO = '/participant-info';
  public static readonly UPDATE_INFO = '/participant-info/update';
}
